import React, { createElement } from 'react';
import './index.css';
import { render } from 'react-dom';
import { App } from './App';
(function () {
  if (typeof window === 'undefined' || (window as any).fbq) return;
  const f = window as any;
  const fbq = f.fbq = function () {
    fbq.callMethod ? fbq.callMethod.apply(fbq, arguments) : fbq.queue.push(arguments);
  };
  if (!f._fbq) f._fbq = fbq;
  fbq.push = fbq;
  fbq.loaded = true;
  fbq.version = '2.0';
  fbq.queue = [];
  const script = document.createElement('script');
  script.async = true;
  script.src = 'https://connect.facebook.net/en_US/fbevents.js';
  const firstScript = document.getElementsByTagName('script')[0];
  firstScript.parentNode?.insertBefore(script, firstScript);
  // Inicializar pixel UNA SOLA VEZ
  fbq('init', '787172030983266');
  fbq('track', 'PageView');
  console.log('✅ Meta Pixel inicializado correctamente: 787172030983266');
  // Noscript fallback
  const noscript = document.createElement('noscript');
  const img = document.createElement('img');
  img.height = 1;
  img.width = 1;
  img.style.display = 'none';
  img.src = 'https://www.facebook.com/tr?id=787172030983266&ev=PageView&noscript=1';
  noscript.appendChild(img);
  document.body.appendChild(noscript);
})();
render(<App data-id="element-308" />, document.getElementById('root'));